import type { WorkSpecRow } from '../types/agreement'
import type { ChecklistTemplateItem } from './checklistTemplates'

/** Map contract document_data.workSpecs to checklist labels. */
export function workSpecsToChecklistItems(
  workSpecs: WorkSpecRow[] | null | undefined
): ChecklistTemplateItem[] {
  if (!Array.isArray(workSpecs) || workSpecs.length === 0) return []
  return workSpecs
    .map((row, index) => {
      const task = String(row.task || '').trim()
      if (!task) return null
      const group = String(row.group || '').trim()
      const label = group ? `${group}: ${task}` : task
      return { label, sort_order: index }
    })
    .filter((row): row is ChecklistTemplateItem => !!row)
}
